<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'golfreservation'">
    <div class="modal-header">
        <h3 class="modal-title">{{ product.name }}</h3>
    </div>
    <div class="modal-body" style="padding:0;" v-show="isVisible('reservation') || isVisible('addplayer')">
        <div class="row">
            <div class="col-xs-12" style="text-align: center;">
                <h2 class="golf-reservation-title">
                    {{ activeReservation.title }}
                </h2>
                <div class="golf-reservation-date">
                    <span>
                        <span>{{ $_formatDateTime($_dateFormat.DATETIME_DAY_NAME, activeReservation.start).ucfirst() }}</span>
                        <span>{{ $_formatDateTime($_dateFormat.DATETIME_DM, activeReservation.start) }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body reservation-modal golf-reservation-modal" 
        style="background: #f7f7f7;" 
        v-show="isVisible('reservation')">
        <div class="row">
            <div class="col-xs-12">
                <div style="text-align: center;margin-bottom: 15px;text-transform: lowercase;font-weight: bold;font-size: 16px;">
                    <span>{{ $_locale('at') }} {{ activeReservation.start.format('HH:mm') }}</span>
                </div>
                
                <golf-player 
                    v-if="(!adminMode && availableSlots + 1 > 0) && !(!adminMode && userAlreadyLinked) && userPlayerValid"
                    :person="userPlayer" 
                    :price="playerPrice(userPlayer)">
                </golf-player>
                <template v-if="selectedPlayers.length > 0">
                    <golf-player 
                        @select="toggleActive('addplayer', true)"
                        v-for="player in selectedPlayers" 
                        :key="player.personId"
                        :person="player"
                        :price="playerPrice(player)">
                    </golf-player>
                </template>
                <template v-if="availableSlots > 0">
                    <div class="golf-player" 
                        @click="toggleActive('addplayer', true)"
                        v-for="index in availableSlots" 
                        :key="index">
                        <div class="availibility-icon">
                            <i class="glyphicon glyphicon-plus"></i>
                        </div>
                        <div class="golf-player-name">{{ $_locale('add a player') }}</div>
                    </div>
                </template>
                <template v-if="linkedPlayers.length > 0">
                    <golf-player
                        :class="{ 'active': player.selected, 'hidden': player.selected && replaceWithPlayers === true }"
                        @select="toggleSelectedReservationPlayer(player)"
                        v-for="player in linkedPlayers" 
                        :key="player.personId"
                        :person="player">
                    </golf-player>
                </template>
                
                <template v-if="disabledTimes.length">
                    <div class="golf-player" 
                        :class="{ 'active': time.selected, 'hidden': time.selected && replaceWithPlayers === true }"
                        @click="toggleSelectedReservationPlayer(time)"
                        v-for="time in disabledTimes" 
                        :key="time.reservationTimeId">
                        <div class="availibility-icon reserved">
                            <i class="glyphicon glyphicon-minus" style="margin-left: -1px;"></i>
                        </div>
                        <div class="golf-player-name">{{ $_locale('disabled tee time slot') }}</div>
                    </div>
                </template>
                
                <div class="clearfix"></div>
                <template v-if="reservationPlayersSelected && replaceWithPlayers === false">
                    <h4>{{ $_locale('edit reservation') }}</h4>
                    <golf-reservation-modifier 
                        style="min-height: 200px"
                        ref="reservationModifier"
                        :defaultResourceId="activeReservation.resourceId"
                        :defaultDate="activeReservation.start" />
                </template>
                <template v-else>
                    <!-- disabled for now, WISE-2801 -->
                    <div class="pull-left" v-if="false">
                        <label>
                            <input type="checkbox" v-model="namePublic">
                            <span>{{ $_locale('show name in tee time') }}</span>
                        </label>
                    </div>
                    <golf-price-summary class="pull-right" 
                        :additionalReservations="additionalReservations" 
                        ref="priceSummary" />
                    <div class="clearfix"></div>
                    
                    <div v-show="!activeReservation.recurringReservation && availableAdditionalResources.length > 0 && blockAvailableQuantity > 0">
                        <h4>{{ $_locale('options') }}</h4>
                        <additional-resource-handler ref="resourceHandler" />
                    </div>
                </template>
            </div>
        </div>
        <div class="" v-show="activeReservation.recurringReservation">
            <h4>{{ $_locale('recurring reservation') }}</h4>
            <div class="row">
                <div class="col-xs-12">
                    {{ $_locale('every %s until date', true, activeReservation.start.format('dddd')) }}
                    <input type="text" class="form-control" ref="dateInput" />
                    <p>{{ activeReservation.recurringDates.length + 1 }} {{ $_locale('weeks selected') }}</p>
                </div>
            </div>
        </div>
    </div>
    
    <!-- v-show so that the $refs.addPlayers is available -->
    <div v-show="isVisible('addplayer')">
        <div class="modal-body reservation-modal golf-reservation-modal" style="background: #f7f7f7;">
            <golf-add-players 
                ref="addPlayers" 
                :toggleActive="toggleActive"
                :hidePlayers="replaceWithPlayers ? selectedReservationPlayers : []" />
        </div>
        <div class="modal-footer" style="margin-top:0px;">
            <button class="btn btn-default pull-left" @click="toggleActive('addplayer', false)">{{ $_locale('return') }}</button>
            <button class="btn btn-success btn-block" @click="savePlayers">{{ $_locale('save players') }}</button>
            <!-- replaceWithPlayers show something when this is true? -->
        </div>
    </div>
    
    <template v-if="isVisible('addvisitorplayer')">
        <div class="modal-body reservation-modal golf-reservation-modal" style="background: #f7f7f7;">
            <golf-add-visitor-player @done="visitorCreated" />
        </div>
        <div class="modal-footer" style="margin-top:0px;">
            <button class="btn btn-default pull-left" @click="toggleActive('addplayer', true)">{{ $_locale('return') }}</button>
        </div>
    </template>
    
    <template v-if="isVisible('reservationList')">
        <div class="modal-body reservation-modal">
            <golf-reservations-list 
                :reservation="activeReservation"
                @selected="toggleActive('editGolfReservation', true)" />
        </div>
        <div class="modal-footer">
            <button class="btn btn-default pull-left" @click="toggleActive('reservationList',false)">{{ $_locale('cancel') }}</button>
        </div>
    </template>

    <template v-if="isVisible('editGolfReservation')">
        <edit-golf-reservation @cancel="toggleActive('reservationList', true)" />
    </template>
    
    <template v-if="isVisible('disableTime')">
        <div class="modal-body reservation-modal">
            <div class="row">
                <div class="col-xs-12">
                    <div style="text-align: center;margin-bottom: 15px;text-transform: lowercase;font-weight: bold;font-size: 16px;">
                        <span>{{ $_locale('at') }} {{ activeReservation.start.format('HH:mm') }}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <h6>{{ $_locale('stretch end time') }} ({{ $_locale('optional', false) }})</h6>
                    <input class="form-control" type="time" ref="disableTimeInput" />
                </div>
                <div class="col-xs-12 col-sm-6" v-show="activeReservation.availableQuantity > 1">
                    <h6>{{ $_locale('specify how many slots are removed from tee time') }}</h6>
                    <div class="input-group" style="">
                        <span class="input-group-btn">
                            <button @click="activeReservation.adjustOrderQuantity(false)" class="btn btn-default" style="margin-right: -1px;">-</button>
                        </span>
                        <input type="text" :value="activeReservation.orderQuantity" class="form-control" style="height: 34px; text-align: center;" :disabled="true" />
                        <span class="input-group-btn">
                            <button @click="activeReservation.adjustOrderQuantity(true, true)" class="btn btn-default" style="margin-left: -1px;">+</button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">
                        <label>{{ $_locale('reason') }}</label>
                        <textarea class="form-control" v-model="disableTimeReason" maxlength="254"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer" style="margin-top:0px;">
            <button class="btn btn-default pull-left" @click="toggleActive('disableTime',false)">{{ $_locale('cancel') }}</button>
            <button class="btn btn-success btn-block" v-if="adminMode" @click="disableTimeBlocks()">{{ $_locale('confirm') }}</button>
        </div>
    </template>

    <div v-show="isVisible('addresourcecomment')">
        <div class="modal-body reservation-modal">
            <edit-resource-comment 
                :resource="activeReservation.resource"
                ref="editResourceComment" 
                @success="resourceCommentOnSuccess" />
        </div>
        <div class="modal-footer" style="margin-top:0px;">
            <button class="btn btn-default pull-left" 
                @click="toggleActive('disableTime',false)">{{ $_locale('cancel') }}</button>
            <button class="btn btn-danger" v-if="isResourceCommentEditMode"
                @click="$refs.editResourceComment.deleteComment()">{{ $_locale('delete') }}</button>
            <button class="btn btn-success btn-block" 
                @click="$refs.editResourceComment.saveComment()">{{ $_locale('save') }}</button>
        </div>
    </div>

    <div class="modal-footer" style="margin-top:0px;" v-if="reservationPlayersSelected && !isVisible('addplayer')">
        <button class="btn btn-default pull-left" @click="cancelReplacePlayers">{{ $_locale('cancel') }}</button>
        <template v-if="replaceWithPlayers">
            <span>{{ selectedReservationPlayers.length }} {{ $_locale('tee times selected', false) }}</span>
        </template>
        <template v-if="!replaceWithPlayers">
            <button class="btn btn-default" 
                    v-if="enableReplaceWithPlayers" 
                    @click="toggleReplaceWithPlayers">
                <span>{{ $_locale('replace with players') }}</span>
            </button>
            <button class="btn btn-warning" @click="copyReservations">{{ $_locale('copy') }}</button>
            <button class="btn btn-danger" @click="deactivateReservations">{{ $_locale('delete') }}</button>
        </template>
        <button class="btn btn-success btn-block" @click="saveReservationsProxy">
            <span>{{ $_locale('save') }}</span>
        </button>
    </div>

    <div class="modal-footer" style="margin-top:0px;" v-show="displayDefaultFooter">
        <button class="btn btn-default pull-left" @click="$store.commit('common/setModal', null)">{{ $_locale('close') }}</button>
        <button class="btn btn-default" v-if="adminMode" @click="toggleActive('addresourcecomment', true)">{{ $_locale('add new') }} {{ $_locale('comment', false) }}</button>
        <button class="btn btn-default" v-if="adminMode && activeReservation.reservations.length" @click="toggleActive('reservationList', true)">{{ $_locale('reservations') }}</button>
        <button class="btn btn-warning" v-if="adminMode && blockAvailableQuantity > 0" @click="toggleActive('disableTime', true)">{{ $_locale('disable times') }}</button>
        <div class="clearfix"></div>
        <template v-if="timeblockComments.length > 0">
            <div class="alert alert-info resource-comment" role="alert" 
                style="text-align:center;margin-top: 15px;margin-bottom: 0px;">
                <p v-for="comment in timeblockComments" 
                    :key="comment.commentId">
                    <button class="btn btn-xs btn-danger pull-right" 
                        @click="deleteComment(comment)"
                        v-if="adminMode">
                        <i class="glyphicon glyphicon-trash"></i>
                    </button>
                    <strong><i class="glyphicon glyphicon-info-sign"></i></strong> {{ comment.comment }}
                </p>
            </div>
        </template>
        
        <button 
            class="btn btn-success btn-block" 
            @click="saveOrder" 
            :disabled="!orderValid"
            v-if="blockAvailableQuantity > 0">
            <span>{{ $_locale('make reservation') }}</span>
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'
import { durationToBlockCount } from '../common/ReservationService.js'
import AdditionalResourceHandler from '../CalendarReservation/AdditionalResourceHandler.vue'
import GolfPlayer from './GolfPlayer.vue'
import GolfReservationsList from './GolfReservationsList.vue'
import GolfPriceSummary from './GolfPriceSummary.vue'
import GolfAddVisitorPlayer from './GolfAddVisitorPlayer.vue'
import EditGolfReservation from './EditGolfReservation.vue'
import GolfAddPlayers from './GolfAddPlayers.vue'
import GolfReservationModifier from './GolfReservationModifier.vue'
import EditResourceComment from '../common/EditResourceComment.vue'

const { formatDateTime, dateFormat, getDateFormat } = window.wisenetwork;
const initialData = () => ({
    visible: 'reservation',
    disableTimeReason: '',
    recurringEndDate: moment(),
    selectAdditionalResources: false,
    selectedBlockIndex: 0,
    additionalReservations: [],
    namePublic: true,
    selectedReservationPlayers: [],
    replaceWithPlayers: false,
    enableReplaceWithPlayers: true,
});

export default {
    components: {
        AdditionalResourceHandler,
        GolfPlayer,
        GolfReservationsList,
        GolfPriceSummary,
        GolfAddVisitorPlayer,
        EditGolfReservation,
        GolfAddPlayers,
        GolfReservationModifier,
        EditResourceComment,
    },
    data: initialData,
    computed: {
        ...mapGetters({
            timeTable: 'calendar/timeTable',
            product: 'ecom/product',
            activeReservation: 'calendar/activeReservation',
            availableAdditionalResources: 'calendar/availableAdditionalResources',
            selectedAdditionalResources: 'calendar/selectedAdditionalResources',
            reviewBlock: 'calendar/reviewBlock',
            loggedIn: 'common/loggedIn',
            adminMode: 'common/adminMode',
            generateReservation: 'reservations/generateReservation',
            weekMode: 'reservations/weekMode',
            date: 'reservations/date',
            resourceCommentsByBlock: 'reservations/resourceCommentsByBlock',
            modalIsOpen: 'common/modalIsOpen',
            userPlayer: 'golf/userPlayer',
            allPlayerPrices: 'golf/allPlayerPrices',
            selectedPlayers: 'golf/selectedPlayers',
            reservationPlayers: 'golf/reservationPlayers',
            mobile: 'common/mobile',
        }),
        userPlayerValid() {
            return this.userPlayer.personId !== null;
        },
        blockAvailableQuantity() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return 0;
            }

            return this.activeReservation.block.availableQuantity;
        },
        availableSlots() {
            const reduction = this.adminMode 
                || (!this.adminMode && !this.userPlayerValid) 
                || (!this.adminMode && this.userAlreadyLinked) ? 0 : 1;
            const value = (this.blockAvailableQuantity - reduction) - this.selectedPlayers.length;

            if (this.replaceWithPlayers) {
                return value + this.selectedReservationPlayers.length;
            }
            // TODO: WISE-3119 - user available slots by accessright rule
            return value;
        },
        playerPrice() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return (person = null) => 0;
            }
            
            const basePrice = this.activeReservation.block.price;

            return (person = null) => {
                if (person === null) return basePrice;

                const priceObj = this.allPlayerPrices.filter(row => row.personId === person.personId)[0];

                return !!priceObj ? priceObj.price : basePrice;
            };
        },
        disabledTimes() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return [];
            }

            return this.activeReservation.block.reservations
                .filter(row => row.status === 4)
                .filter(row => {
                    const start = moment(row.start);
                    const end = moment(row.end);
                    const diff = Math.abs(moment(start).diff(moment(end), 'minutes'));

                    return diff <= this.activeReservation.duration;
                })
                .map(row => {
                    row.selected = this.selectedReservationPlayers.indexOf(row.reservationTimeId) > -1;

                    return row;
                })
        },
        linkedPlayers() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return [];
            }

            const reservations = this.activeReservation.block.reservations.map(
                row => row.reservationTimeId
            );

            return this.reservationPlayers.filter(
                row => reservations.indexOf(row.reservationTimeId) > -1
            ).map(row => {
                const player = { ...row };
                const playerIsUser = player.personId === this.userPlayer.personId;

                player.selected = this.selectedReservationPlayers.indexOf(player.reservationTimeId) > -1;
                
                if ((!this.loggedIn || !row.namePublic) && !playerIsUser) {
                    player.firstName = this.$_locale('reserved');
                    player.familyName = '';
                    player.clubAbbreviation = '';
                }
                
                return player;
            })
        },
        userAlreadyLinked() {
            return this.linkedPlayers.filter(row => row.personId === this.userPlayer.personId).length > 0
        },
        orderValid() {
            const add = this.userAlreadyLinked ? 0 : 1;

            if (this.selectedPlayers.length + add === 0) return false;

            if (!this.adminMode && !this.userAlreadyLinked && !this.userPlayerValid) return false;

            return true;
        },
        displayDefaultFooter() {
            return !this.isVisible('disableTime') 
                && !this.isVisible('reservationList') 
                && !this.isVisible('addplayer')
                && !this.isVisible('addvisitorplayer')
                && !this.isVisible('addresourcecomment')
                && !this.isVisible('editGolfReservation')
                && !this.reservationPlayersSelected
        },
        reservationPlayersSelected() {
            return this.selectedReservationPlayers.length > 0;
        },
        timeblockComments() {
            if (this.activeReservation === null 
                || this.activeReservation.placeholder
                || typeof this.activeReservation.block === 'undefined') {
                return [];
            }
            
            return this.resourceCommentsByBlock(this.activeReservation.block);
        },
        isResourceCommentEditMode() {
            const element = this.$refs.editResourceComment;

            if (!element) return false;

            return element.isEdit();
        },
    },
    watch: {
        modalIsOpen(val) {
            
            if (!val) {
                const data = initialData();

                Object.keys(data).forEach((key) => {
                    this[key] = data[key];
                })

                this.$store.commit('golf/setSelectedPlayers', []);
            } else {
                if (this.adminMode) {
                    if(this.$store.getters['common/modalName'] !== 'golfreservation') return;
                    
                    this.$refs.editResourceComment.setDateStartTime(
                        this.activeReservation.start.format('YYYY-MM-DD HH:mm:ss'), 
                        10
                    );
                }
            }
        },
        'activeReservation.recurringReservation': {
            handler(value) {
                if (!value) {
                    return;
                }
                const { daterangepicker } = window.wisenetwork
                const input = this.$refs.dateInput;
                const dayNameShort = getDateFormat(dateFormat.DATETIME_DAY_NAME_SHORT);
                const format = getDateFormat(dateFormat.DATETIME_DMY);

                if (this.mobile) {
                    input.readOnly = true;
                }
                
                const picker = daterangepicker(
                    input,
                    {
                        locale: { 
                            format: dayNameShort+' '+format,
                            daysOfWeek: _localeDates.dayNamesMin,
                            monthNames: _localeDates.monthNamesShort,
                            firstDay: 1,
                        },
                        opens: 'right',
                        showWeekNumbers: true,
                        singleDatePicker: true,
                        showDropdowns: true,    
                        startDate: this.activeReservation.start,
                    }, 
                    (startDate, endDate) => {
                        this.recurringEndDate = startDate;
                        const resObj = this.activeReservation;
                        const times = [];
                        const delta = resObj.start.clone(); // .startOf('isoWeek')
                        const end = this.recurringEndDate.clone();
                        const { overNight } = resObj;

                        end.add(24, 'hours')

                        while(delta <= end) {
                            delta.add(1, 'weeks')
                            times.push({
                                start: delta.clone().set({ 
                                    hour: resObj.start.format('H'), 
                                    minute: resObj.start.format('m') 
                                }).format('YYYY-MM-DD HH:mm:ss'),
                                end: delta.clone()
                                .add(overNight ? 24 : 0, 'hours')
                                .set({ 
                                    hour: resObj.end.format('H'), 
                                    minute: resObj.end.format('m')
                                }).format('YYYY-MM-DD HH:mm:ss')
                            })
                        }
                        //console.log('apply.daterangepicker', times);

                        resObj.recurringDates = times;

                        if (this.additionalReservations.length > 0) {
                            this.additionalReservations.forEach((resObj) => {
                                resObj.recurringDates = times;
                            })
                        }
                    }
                )
            }
        }
    },
    methods: {
        isVisible(name) {
            return name === this.visible; 
        },
        savePlayers() {
            const { added, removed } = this.$refs.addPlayers.getPlayers();
            
            added.forEach(personId => {
                this.$store.commit('golf/selectPlayer', personId);
            })
            removed.forEach(personId => {
                this.$store.commit('golf/deselectPlayer', personId);
            })
            
            this.activeReservation.setOrderQuantity(
                this.selectedPlayers.length + (this.adminMode ? 0 : 1),
                true
            );
            this.$refs.addPlayers.reset();
            this.toggleActive('addplayer', false);
        },
        visitorCreated(player) {
            // GolfAddPlayers component is responsible for handling tee time players
            const addPlayers = this.$refs.addPlayers;
            addPlayers.selectPlayer(player);
            this.toggleActive('addplayer', true);
        },
        cancelReplacePlayers() {
            this.selectedPlayers.forEach(row => {
                this.$store.commit('golf/deselectPlayer', row.personId);
            });
            this.selectedReservationPlayers = [];
            this.replaceWithPlayers = false;
        },
        toggleActive(name, value) {
            this.visible = value ? name : 'reservation';

            if (name === 'disableTime') {
                this.activeReservation.setOrderQuantity(value ? 4 : 0);
            }
        },
        deleteComment(comment) {
            const elem = this.$refs.editResourceComment;

            elem.init(comment);
            elem.deleteComment()
                .then((response) => {
                    const { data } = response;
                });
        },
        resourceCommentOnSuccess(evt) {
            if (evt.type === 'push') {
                this.toggleActive('addresourcecomment',false)
            } else if (evt.type === 'delete') {

            }
        },
        disableTimeBlocks() {
            const disableTimeInput = this.$refs.disableTimeInput;
            const disableTimeEnd = disableTimeInput.value;
            const disableTimeReason = this.disableTimeReason;
            
            if (!this.adminMode) {
                return;
            }

            // instead of having one disabled time row with a quantity
            // create as many rows as selected quantity so that they
            // can be moved and deleted separately
            const quantity = this.activeReservation.orderQuantity;
            this.activeReservation.orderQuantity = 1;

            const sample = this.activeReservation.format()[0];
            const oldEnd = moment(sample.end);
            const newEnd = moment(`${ oldEnd.format('YYYY-MM-DD') } ${ disableTimeEnd }:00`);
            const times = [];
            const rows = [];
            let useNewEnd = false;
            
            // time is in string format like HH:mm
            if (disableTimeEnd.length > 0) {
                // test if the newEnd is legit
                if (newEnd > oldEnd) {
                    const delta = moment(sample.start);

                    while (delta < newEnd) {
                        const newStart = delta.format('YYYY-MM-DD HH:mm:ss');
        
                        delta.add(sample.duration, 'minutes')

                        times.push({ 
                            start: newStart,
                            end: delta.format('YYYY-MM-DD HH:mm:ss')
                        })
                    }

                    useNewEnd = true;
                }
            } else {
                times.push({ 
                    start: sample.start,
                    end: sample.end
                })
            }
            
            times.forEach(row => {
                const clone = JSON.parse(JSON.stringify(sample)); // deep copy
                
                clone.start = row.start;
                clone.end = row.end;

                for(let i = 0;i < quantity;i++) {
                    rows.push(clone)
                }
            })

            console.log(times, rows)
            
            const data = {
                forClient: true,
                products: rows.map(reservation => ({
                    productId: this.product.productId,
                    productVariantId: 0,
                    quantity: reservation.quantity * reservation.resources[0].quantity,
                    reservation
                })),
                //extraInformation: disableTimeReason
            };
            const comment = {
                resourceId: this.activeReservation.resourceId,
                commentId: null,
                comment: disableTimeReason.trim(),
                dateTimeStart: sample.start,
                dateTimeEnd: useNewEnd ? newEnd.format('YYYY-MM-DD HH:mm:ss') : sample.end,
                public: false,
                deleted: false,
            }
            
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$store.commit('common/setModal', null)
            
            EcomService.disableTime(data)
            .then((response) => {
                const data = response.data;

                if (data.success) {
                    if (disableTimeReason.trim().length > 0) {
                        this.$store.dispatch('reservations/addResourceComment', comment);
                    }
                    
                    this.$store.dispatch('reservations/onDateChange', this.date);
                    this.$_swal({ icon: 'success', title: _locale('time disabled').ucfirst() })
                } else {
                    this.$_swal({ icon: 'error', html: data.errors.map((err) => `<p>${ _locale(err.message).ucfirst() }</p>`).join('') })
                }
            })
        },
        saveOrder() {
            const add = this.userAlreadyLinked ? 0 : 1;

            if (this.selectedPlayers.length + add === 0) {
                this.$_swal({ icon: 'error', title: _locale('no players selected for a tee time').ucfirst() })
                return;
            }
            
            const resourceHandler = this.$refs.resourceHandler;

            if (!this.activeReservation.recurringReservation &&
                (!resourceHandler.isMandatoryProductsSelected() ||
                !resourceHandler.isMandatoryResourcesSelected())) {
                this.$_swal({ icon: 'error', title: _locale('mandatory products are not set').ucfirst() })
                return false;
            }

            /**
             * Figure out how to create separate rows by players if they
             * have different access right category ids
             */
            let rows = this.activeReservation.format();
            let additionalResources = [];
            let additionalResourceReservations = [];

            if (this.additionalReservations.length > 0) {
                this.additionalReservations.forEach((resObj) => {
                    resObj.recurringReservation = this.activeReservation.recurringReservation;
                    
                    rows = rows.concat(resObj.format())
                })
            }

            if (!this.activeReservation.recurringReservation
                && this.availableAdditionalResources.length > 0) {
                additionalResources = this.selectedAdditionalResources.filter(row => row.productType !== 6); // non reservations
                additionalResourceReservations = this.selectedAdditionalResources.filter(row => row.productType === 6);
            }

            const tmpRows = rows.map((reservation, i) => {
                const row = {
                    productId: this.product.productId,
                    productVariantId: 0,
                    quantity: reservation.quantity * reservation.resources[0].quantity,
                    reservation
                }
                
                //console.log(reservation.resources);
                // additional resources disabled from recurring reservations for now
                // the resevation type product carries the resource detail
                // if the resource is a product, add it as a children cartproduct
                // this.additionalReservations.length === 0 
                if (i === 0) {
                    if (additionalResources.length > 0) {
                        reservation.resources = [
                            ...reservation.resources,
                            ...additionalResources.map((resource) => ({
                                resourceId: resource.resourceId,
                                resourceName: resource.resourceName,
                                quantity: resource.orderQuantity,
                                option: resource.option,
                                productId: resource.productId,
                                personId: resource.personId
                            }))
                        ];

                        row.childrenProducts = additionalResources.map((resource) => ({
                            quantity: resource.orderQuantity,
                            productId: resource.productId,
                            productVariantId: 0
                        }))
                    }
                }

                return row;
            });
            const golfPlayers = [
                ...this.selectedPlayers
            ]

            if (!this.adminMode && !this.userAlreadyLinked) {
                golfPlayers.unshift(this.userPlayer)
            }

            const golfPlayersHandicapTotal = [
                ...golfPlayers,
                ...this.linkedPlayers,
            ].reduce((acc, curr) => acc + parseFloat(curr.handicapActive), 0);
            const golfPlayersTotal = golfPlayers.length + this.linkedPlayers.length;
            const golfPersonIds = [
                ...golfPlayers,
                ...this.linkedPlayers,
            ].map(row => row.personId)
            
            const orderRows = golfPlayers.map((player, i) => {
                const orderRow = JSON.parse(JSON.stringify(tmpRows[0])); // deep copy

                orderRow.golfPlayers = [player];
                orderRow.golfPersonIds = golfPersonIds; // helper array
                orderRow.golfPlayersTotal = golfPlayersTotal;
                orderRow.golfPlayersHandicapTotal = golfPlayersHandicapTotal;
                orderRow.golfPlayerNamePublic = this.namePublic;
                orderRow.quantity = 1;
                orderRow.reservation.resources[0].quantity = 1;

                if (i > 0) {
                    delete orderRow.childrenProducts;
                }

                return orderRow
            })

            // add additionalResourceReservations as normal reservation rows
            // these are additional products that are type 6 (reservation)
            additionalResourceReservations.map((resource) => {
                const start = this.activeReservation.start.clone();
                // by default, use resource min duration (this was just implemented first)
                let end = start.clone().add(resource.productReservationMinDuration, 'minutes');
                let quantity = resource.productReservationMinDuration / resource.productReservationDuration;
                // also an option to use same duration as activeReservation
                if (resource.option == 2) {
                    end = this.activeReservation.end.clone();
                    quantity = durationToBlockCount(start, end, resource.productReservationDuration);
                }
                
                const reservation = {
                    reservationId: resource.productReservationId,
                    start: start.format('YYYY-MM-DD HH:mm:ss'),
                    end: end.format('YYYY-MM-DD HH:mm:ss'),
                    resources: [
                        {
                            resourceId: resource.resourceId,
                            quantity: resource.orderQuantity,
                            resourceName: resource.resourceName
                        }
                    ]
                }

                return {
                    quantity,
                    productId: resource.productId,
                    productVariantId: 0,
                    reservation
                };
            })
            .forEach(row => orderRows.push(row))
            //console.log('orderRows', orderRows)
            //return;

            const data = {
                products: orderRows
            };
            let gotoCheckout = true;
            
            this.$store.commit('common/setModal', null)

            if (this.adminMode) {
                data.forClient = true;
                // this.$refs.priceSummary.getTotalPrice() > 0 && 
                // 20.12.2021 - always ask admin for proceeding
                if (!this.replaceWithPlayers) {
                    return this.$_swal({
                        title: _locale('Proceed to checkout').ucfirst() + '?',
                        text: '',
                        type: 'success',
                        showCancelButton: true,
                        confirmButtonClass: 'btn-success',
                        confirmButtonText: _locale('Proceed to checkout').ucfirst(),
                        cancelButtonText: _locale('save order').ucfirst()
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            this.addToCart(data);
                        } else {
                            data.forceMockOrder = true;
                            this.createMockReservation(data);
                        }
                    })
                } else {
                    gotoCheckout = false;
                }
            } else if (this.$refs.priceSummary.getTotalPrice() === 0) {
                gotoCheckout = false;
            }
            
            if (gotoCheckout) {
                this.addToCart(data);
            } else {
                this.createMockReservation(data);
            }
        },
        createMockReservation(orderData) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            EcomService.createMockReservation(orderData)
            .then((response) => {
                const data = response.data;

                if (data.success) {
                    this.$store.dispatch('reservations/onDateChange', this.date);
                    this.$_swal({ icon: 'success', title: _locale('reservation').ucfirst() + ' ' + _locale('succeeded') })

                    if (!orderData.forClient && data.orderId && data.hash) {
                        EcomService.activateOrder(data.orderId, data.hash)
                    }
                } else {
                    // this could fail because of price > 0 and no privileges
                    if (orderData.forceMockOrder) {
                        this.$_swal({ icon: 'error', html: data.errors.map((err) => `<p>${ _locale(err.message).ucfirst() }</p>`).join('') })
                    } else {
                        const groupDayLimitError = data.errors.filter(row => row.id === 'groupDayLimitError')[0]

                        if (groupDayLimitError) {
                            return this.$_swal({
                                title: groupDayLimitError.message,
                                text: '',
                                showCancelButton: true,
                                confirmButtonText: _locale('Proceed to checkout').ucfirst(),
                                cancelButtonText: _locale('cancel').ucfirst()
                            })
                            .then((result) => {
                                if (result.isConfirmed) {
                                    this.addToCart(orderData);
                                }
                            })
                        }

                        this.addToCart(orderData);
                    }
                }
            })
        },
        addToCart(data) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            // check reservation type when to use addtocart
            // some reservations are paid afterwards locally
            EcomService.addToCart(data)
            .then((response) => {
                const data = response.data;
                const success = data.products.length > 0 && data.products.reduce((acc, curr) => curr.success === false ? false : acc, true);

                if (success) {
                    const isEmbed = this.$store.getters['common/isEmbed'];

                    if (isEmbed) {
                        const postData = {
                            type: 'spacheckout',
                            url: this.$store.getters['common/checkoutUrl']
                        }
                        
                        window.top.postMessage(JSON.stringify(postData), '*');
                    } else {
                        location.href = this.$store.getters['common/checkoutUrl'];
                    }
                } else {
                    if (!data.products.length) {
                        this.$_swal({ icon: 'error', title: _locale('The product could not be added to the cart') })
                    } else {
                        const errors = data.products
                        .reduce((acc, curr) => {
                            return [...acc,...curr.errors];
                        }, [])
                        .reduce((acc, curr) => {
                            acc[curr.error] = curr.message;
                            return acc;
                        }, {});
                        this.$_swal({ icon: 'error', html: Object.values(errors).map((err) => `<p>${ _locale(err).ucfirst() }</p>`).join('') })
                    }
                }
            })
        },
        toggleSelectedReservationPlayer(player) {
            if (!this.adminMode) {
                return;
            }
            const selected = this.selectedReservationPlayers;
            const index = selected.indexOf(player.reservationTimeId);

            if (index > -1) {
                selected.splice(index, 1);
            } else {
                selected.push(player.reservationTimeId);
            }
        },
        // copy reservations to another time from the modifier
        copyReservations() {
            const selected = this.selectedReservationPlayers; // reservationTimeIds...
            const golfPlayers = this.linkedPlayers.filter(row => selected.indexOf(row.reservationTimeId) > -1)
            const modifier = this.$refs.reservationModifier;
            const sample = this.activeReservation.format()[0];
            const reservations = this.activeReservation.reservations.filter(
                row => selected.indexOf(row.reservationTimeId) > -1
            );
            const dataRows = reservations.map(row => modifier.formatReservation(row))
            
            if (sample.start == dataRows[0].dateTimeStart) {
                return;
            }
            
            const golfPlayersHandicapTotal = [
                ...golfPlayers,
            ].reduce((acc, curr) => acc + parseFloat(curr.handicapActive), 0);
            const golfPlayersTotal = golfPlayers.length;
            const golfPersonIds = [
                ...golfPlayers,
            ].map(row => row.personId)

            const orderRows = golfPlayers.map((player, i) => {
                const { personId, firstName, familyName, playerId, isDataPublic, handicapActive, clubName, clubAbbreviation, memberNO, clubId } = player;
                const reservation = JSON.parse(JSON.stringify(sample)); // deep copy
                const orderRow = {
                    productId: this.product.productId,
                    productVariantId: 0,
                    reservation
                }
                
                orderRow.golfPlayers = [{ personId, firstName, familyName, playerId, isDataPublic, handicapActive, clubName, clubAbbreviation, memberNO, clubId }];
                orderRow.golfPersonIds = golfPersonIds; // helper array
                orderRow.golfPlayersTotal = golfPlayersTotal;
                orderRow.golfPlayersHandicapTotal = golfPlayersHandicapTotal;
                orderRow.golfPlayerNamePublic = this.namePublic;
                orderRow.quantity = 1;
                orderRow.reservation.start = dataRows[0].dateTimeStart;
                orderRow.reservation.end = dataRows[0].dateTimeEnd;
                orderRow.reservation.resources[0].quantity = 1;

                if (i > 0) {
                    delete orderRow.childrenProducts;
                }

                return orderRow
            });

            /* 
                - use dataRows[0] as a template
                - collect golfplayers array and details to
                go with them
                - map golfplayers with the template like in the normal order
            */

            const data = {
                forClient: true,
                products: orderRows,
            }
            console.log('copy reservations', data)
            
            this.$store.commit('common/setModal', null);
            this.createMockReservation(data)
        },
        toggleReplaceWithPlayers() {
            if (this.replaceWithPlayers) {
                this.replaceWithPlayers = false;
            } else {
                this.replaceWithPlayers = true;
                this.toggleActive('addplayer', true);
            }
        },
        saveReservationsProxy() {
            if (!this.replaceWithPlayers) {
                return this.saveReservations();
            }

            this.deactivateReservationTimes(this.selectedReservationPlayers)
            .then((result) => {
                const success = result.filter(row => !row.data.success).length === 0;

                if (success) {
                    this.saveOrder();
                }
            })
        },
        saveReservations() {
            const selected = this.selectedReservationPlayers;
            const modifier = this.$refs.reservationModifier;
            const reservations = this.activeReservation.reservations.filter(
                row => selected.indexOf(row.reservationTimeId) > -1
            );
            const dataRows = reservations.map(row => modifier.formatReservation(row))
            
            this.$store.commit('common/setModal', null);
            
            Promise.all(
                dataRows.map(row => this.saveEditedReservation(row))
            )
            .then((result) => {
                const success = result.filter(row => !row.data.success).length === 0;

                if (success) {
                    this.$store.dispatch('reservations/onDateChange', this.date)

                    this.$_swal({ icon: 'success', title: _locale('reservation saved').ucfirst() })
                } else {
                    const message = result.filter(row => !!row.data.message)
                    .reduce(
                        (prev, curr) => {
                            return [
                                ...prev,
                                curr.data.message
                            ]
                        }, 
                        []
                    )
                    this.$_swal({ icon: 'error', title: message.join("\n") })
                }
            })
        },
        saveEditedReservation(data) {
            const EcomService = this.$store.getters['ecom/EcomService'];

            return EcomService.editReservationTime(data);
        },
        deactivateReservations() {
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('common/setModal', null);
                    this.deactivateReservationTimes(this.selectedReservationPlayers)
                    .then((result) => {
                        const success = result.filter(row => !row.data.success).length === 0;

                        if (success) {
                            this.$store.dispatch('reservations/onDateChange', this.date);
                            
                            this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                        }
                    })
                }
            })
        },
        deactivateReservationTimes(reservationTimes) {
            return Promise.all(
                reservationTimes.map(
                    reservationTimeId => this.deactivateReservationTime(reservationTimeId)
                )
            )
            .then((result) => {
                const success = result.filter(row => !row.data.success).length === 0;

                if (!success) {
                    const message = result.filter(row => !!row.data.message)
                    .reduce(
                        (prev, curr) => {
                            return [
                                ...prev,
                                curr.data.message
                            ]
                        }, 
                        []
                    )
                    this.$_swal({ icon: 'error', title: message.join("\n") })
                }

                return result;
            })
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            return EcomService.deactivateReservationTime(reservationTimeId)
        },
    }
}
</script>
